import { ErrorMsg } from './ErrorMsg'; // eslint-disable-line
import React from 'react';
import styled from 'styled-components';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { ANIMATIONS } from 'shared/design-system/settings/variables/Animation';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import TrueImpactAnimation from 'shared/design-system/base/TrueImpactAnimation';
import { TYPOGRAPHY } from 'shared/design-system/settings/variables/Typography';
import ShowGuidanceText from './Review/ReportCustomQuestionType/ShowGuidanceText';

export const SectionBase = ({
  title,
  subTitle,
  helpText,
  helpTextMaxWidth = 540,
  children,
  error = [],
  extraClass = '',
  guidanceText,
  questionId,
}) => {
  return (
    <Section className={`${extraClass}`} helpTextMaxWidth={helpTextMaxWidth}>
      <QuestionInfo className="question-info">
        {/* {title && (
              <TrueImpactAnimation variant="appear" animationDelay={2}>
                <ReportBuilderHeading variant="heading-label" className="label">
                  {title}
                </ReportBuilderHeading>
              </TrueImpactAnimation>
            )} */}
        {subTitle && (
          <TrueImpactAnimation variant="appear" animationDelay={3}>
            <ReportBuilderHeading
              variant="heading-page"
              className="question-title"
            >
              {subTitle}
            </ReportBuilderHeading>
          </TrueImpactAnimation>
        )}
        <ShowGuidanceText questionId={questionId} guidanceText={guidanceText} />
        {helpText && (
          <TrueImpactAnimation variant="appear" animationDelay={4}>
            <TrueImpactText variant="body" className="help-text">
              {helpText}
            </TrueImpactText>
          </TrueImpactAnimation>
        )}
      </QuestionInfo>
      {Array.isArray(error) &&
        error.map(({ text, dbId }) => (
          <ErrorMsg key={dbId ?? text} error={text} />
        ))}
      {children}
    </Section>
  );
};

const ReportBuilderHeading = styled(TrueImpactText)`
  max-width: 720px;
  .program-name {
    font-style: ${TYPOGRAPHY.fontStyleItalic};
  }
`;

const Section = styled.div`
  padding: ${SPACERS.large} ${SPACERS.large} 120px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;

  .help-text {
    max-width: ${({ helpTextMaxWidth }) => helpTextMaxWidth}px;
    margin: 0 auto;
  }
  .requirement {
    margin-bottom: ${SPACERS.small};
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type='number'] {
    -moz-appearance: textfield;
  }
`;

const QuestionInfo = styled.div`
  text-align: center;
  margin-bottom: ${SPACERS.medium};
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const CSIMages = styled.div`
  position: relative;
  display: inline-block;
  left: 24px;
  margin: 0 auto;
  img {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    border: 4px solid ${COLORS.whiteBase};
  }
  .image-wrapper,
  .help-icon-wrapper {
    position: relative;
    transition: transform .15s ${ANIMATIONS.animationEasing};
    margin: 0 auto ${SPACERS.large};
    display: inline-block;
  }
  .help-icon-wrapper {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    right: 24px;
    border-radius: 50%;
    background-color: ${COLORS.highlightBackground};
    transition: box-shadow 150ms ${ANIMATIONS.easing};
    :hover {
      @keyframes pulseShadow {
        0% {
          box-shadow: 0px 0px 0px 4px rgba(54, 143, 158, 0);
        }
        25% {
          box-shadow: 0px 0px 0px 4px ${COLORS.highlight};
        }
        50% {
          box-shadow: 0px 0px 0px 4px rgba(54, 143, 158, 0);
        }
        75% {
          box-shadow: 0px 0px 0px 4px ${COLORS.highlight};
        }
        100% {
          box-shadow: 0px 0px 0px 4px rgba(54, 143, 158, 0);
        }
      }
      /* box-shadow: 0px 0px 0px 4px ${COLORS.highlight}; */
      animation-name: pulseShadow;
      animation-duration: 3s;
      animation-timing-function: ${ANIMATIONS.easing};
      animation-fill-mode: forwards;
      animation-iteration-count: infinite;
    }
    svg {
      height: 24px;
      width: 24px;
      color: ${COLORS.highlight};
    }
  }
  .image-wrapper {
    /* Probably don't need this */
    /* cursor: pointer; */
    &:nth-child(2) {
      left: -16px;
    }
    &:nth-child(3) {
      left: -32px;
    }
    &:nth-child(4) {
      left: -48px;
    }
  }
`;
